import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "../api.config";

export const probateHeirsApi = createApi({
  reducerPath: "probateHeirsApi",
  baseQuery: baseQueryWithReauth,
  tagTypes: ["ProbateHeir"],
  endpoints: (build) => ({
    getAllHeirs: build.query({
      query: ({ caseId, status, search, starred, page = 1, limit = 100 } = {}) => ({
        url: "/probate/heirs",
        method: "GET",
        params: { caseId, status, search, starred, page, limit },
      }),
      providesTags: ["ProbateHeir"],
    }),

    getHeirById: build.query({
      query: (id) => ({ url: `/probate/heirs/${id}`, method: "GET" }),
      providesTags: (result, error, id) => [{ type: "ProbateHeir", id }],
    }),

    getHeirsForCase: build.query({
      query: (caseId) => ({ url: `/probate/heirs/case/${caseId}`, method: "GET" }),
      providesTags: ["ProbateHeir"],
    }),

    createHeir: build.mutation({
      query: (heir) => ({ url: "/probate/heirs", method: "POST", body: heir }),
      invalidatesTags: ["ProbateHeir", "ProbateCase"],
    }),

    updateHeir: build.mutation({
      query: ({ id, ...heir }) => ({ url: `/probate/heirs/${id}`, method: "PUT", body: heir }),
      invalidatesTags: (result, error, { id }) => [{ type: "ProbateHeir", id }, "ProbateHeir"],
    }),

    deleteHeir: build.mutation({
      query: (id) => ({ url: `/probate/heirs/${id}`, method: "DELETE" }),
      invalidatesTags: ["ProbateHeir", "ProbateCase"],
    }),

    updateHeirStatus: build.mutation({
      query: ({ id, status }) => ({ url: `/probate/heirs/${id}/status`, method: "PATCH", body: { status } }),
      invalidatesTags: (result, error, { id }) => [{ type: "ProbateHeir", id }, "ProbateHeir"],
    }),

    toggleHeirStar: build.mutation({
      query: (id) => ({ url: `/probate/heirs/${id}/star`, method: "PATCH" }),
      invalidatesTags: (result, error, id) => [{ type: "ProbateHeir", id }, "ProbateHeir"],
    }),

    // Outreach log
    getOutreachLog: build.query({
      query: (id) => ({ url: `/probate/heirs/${id}/outreach`, method: "GET" }),
      providesTags: (result, error, id) => [{ type: "ProbateHeir", id }],
    }),

    addOutreachLog: build.mutation({
      query: ({ id, ...entry }) => ({ url: `/probate/heirs/${id}/outreach`, method: "POST", body: entry }),
      invalidatesTags: (result, error, { id }) => [{ type: "ProbateHeir", id }, "ProbateHeir"],
    }),
  }),
});

export const {
  useGetAllHeirsQuery,
  useGetHeirByIdQuery,
  useGetHeirsForCaseQuery,
  useCreateHeirMutation,
  useUpdateHeirMutation,
  useDeleteHeirMutation,
  useUpdateHeirStatusMutation,
  useToggleHeirStarMutation,
  useGetOutreachLogQuery,
  useAddOutreachLogMutation,
} = probateHeirsApi;
